import React, { type JSX } from 'react';
import { gql } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import UrvalQuery from '../SavedUrval/Queries/NodeUrvalQuery/NodeUrvalQuery';
import { IUIUrval } from '../../../../Types/UrvalTypes';

import { ModelContextConsumer } from '../../../../Model/ModelContext/ModelContext';
import { convertUrval } from '../SavedUrval/Utils/convertSavedUrval';
import Logger from '../../../../Utils/Logger';

interface IChildProperties {
  kodbehorigheturval?: IUIUrval;
}

interface IProps {
  collectionName: string;
  sysUrvalID?: string;
  children: (childProperties: IChildProperties) => JSX.Element;
}

const query = gql`
  query KodbehorigheturvalGQIDQuery($sysUrvalID: ID!) {
    node(id: $sysUrvalID) {
      id
      __typename
      ... on TEDSYSUrval {
        id
        _version
        SelectionGQID
      }
    }
  }
`;

interface ITEDSYSUrvalNode {
  id: string;
  __typename: string;
  SelectionGQID: string;
}

interface IData {
  node: ITEDSYSUrvalNode | null;
}

interface IVariables {
  sysUrvalID: string;
}

const Kodbehorigheturval: React.FunctionComponent<IProps> = props => {
  const skip = !props.sysUrvalID;

  return (
    <Query<IData, IVariables>
      skip={skip}
      query={query}
      variables={{ sysUrvalID: props.sysUrvalID ? props.sysUrvalID : '' }}
    >
      {({ loading, error, data }) => {
        const urvalSkipped = loading || data == null || data.node == null;
        const urvalGQLID =
          !loading && data != null && data.node != null
            ? data.node.SelectionGQID
            : undefined;
        if (error) {
          Logger.error(error);
        }
        return (
          <ModelContextConsumer>
            {({ avenyCollectionMap }) => (
              <UrvalQuery id={urvalGQLID}>
                {({ urval, loading, error }) => {
                  if (urval == null) {
                    if ((!urvalSkipped && !loading) || error) {
                      Logger.error(
                        `Could not find urval with id: ${urvalGQLID}`,
                        error
                      );
                    }
                    return props.children({});
                  } else {
                    return props.children({
                      kodbehorigheturval: convertUrval(
                        urval,
                        props.collectionName,
                        avenyCollectionMap
                      ),
                    });
                  }
                }}
              </UrvalQuery>
            )}
          </ModelContextConsumer>
        );
      }}
    </Query>
  );
};

export default Kodbehorigheturval;
